import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';

interface AssessmentTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  variant?: 'filled' | 'outlined' | 'standard';
  fullWidth?: boolean;
  sx?: object;
}

const AssessmentTypeSelect: React.FC<AssessmentTypeSelectProps> = ({
  value,
  onChange,
  label = 'Assessment Type',
  disabled = false,
  required = false,
  error = false,
  variant = 'filled',
  fullWidth = true,
  sx = {},
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  const defaultSx = {
    background: 'white',
    width: fullWidth ? '98%' : 'auto',
    mt: 0,
    '& .MuiFilledInput-root': {
      backgroundColor: 'white',
      '&:hover': {
        backgroundColor: 'white',
      },
      '&.Mui-focused': {
        backgroundColor: 'white',
      },
    },
    '& .MuiInputLabel-root': {
      ml: 1.5,
    },
    ...sx,
  };

  return (
    <FormControl 
      variant={variant}
      disabled={disabled}
      required={required}
      error={error}
      sx={defaultSx}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || ''}
        onChange={handleChange}
        sx={{ mt: 0, ml: 2 }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 200,
              '& .MuiMenuItem-root': {
                fontSize: '14px',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              },
            },
          },
        }}
      >
        <MenuItem value="Initial Assessment">Initial Assessment</MenuItem>
        <MenuItem value="Reassessment">Reassessment</MenuItem>
      </Select>
    </FormControl>
  );
};

export default AssessmentTypeSelect;